// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../delete-button/icon--delete.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.comments_content_nrpnl {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    padding: 0.5rem;
}

.comments_metadata_ov0ZF,
.comments_actions_OFCZK {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.comments_compose_hPme1,
.comments_list_wRH73 {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.875rem;
    line-height: 1.5;
    color: var(--text-primary);
}

.comments_compose_hPme1,
.comments_comment_G7vkz {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.comments_avatar-container_HOEt7 {
    width: 3rem;
    height: 3rem;
    flex: 0 0 3rem;
}

.comments_avatar_GeUVF {
    box-sizing: border-box;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 4px;
    object-fit: cover;
}

.comments_body_TkxeC {
    flex: 1;
    min-width: 0;
}

.comments_input_ZfZgn {
    box-sizing: border-box;
    display: block;
    width: 100%;
    min-height: 5rem;
    padding: 0.75rem;
    border: 2px solid var(--ui-black-transparent);
    border-radius: 5px;
    resize: vertical;
    background: var(--input-background);
    color: var(--text-primary);
    font: inherit;
}

.comments_input_ZfZgn:focus {
    outline: none;
    border-color: var(--looks-secondary);
}

.comments_actions_OFCZK {
    margin-top: 0.4rem;
}

.comments_button_x1QJL,
.comments_secondary-button_l5cgD {
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    padding: 0.6rem 1rem;
    background: var(--looks-secondary);
    color: white;
    font: inherit;
    font-weight: bold;
}

.comments_secondary-button_l5cgD {
    border-color: var(--ui-black-transparent);
    background: var(--ui-tertiary);
    color: var(--text-primary);
}

.comments_button_x1QJL:disabled,
.comments_secondary-button_l5cgD:disabled,
.comments_input_ZfZgn:disabled {
    cursor: default;
    opacity: 0.55;
}

.comments_button_x1QJL:focus-visible,
.comments_secondary-button_l5cgD:focus-visible {
    outline: 2px solid var(--looks-secondary);
    outline-offset: 2px;
}

.comments_counter_tj80N {
    -webkit-margin-start: auto;
            margin-inline-start: auto;
    font-size: 0.75rem;
}

.comments_list_wRH73 {
    list-style: none;
    padding: 0;
    margin: 1.5rem 0 0;
}

.comments_metadata_ov0ZF {
    margin-bottom: 0.5rem;
}

.comments_metadata_ov0ZF a {
    color: var(--link-color);
    font-weight: bold;
    text-decoration: none;
}

.comments_metadata_ov0ZF a:hover {
    text-decoration: underline;
}

.comments_metadata_ov0ZF time {
    font-size: 0.75rem;
}

.comments_bubble_EoxhN {
    position: relative;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0 0.5rem 0.5rem 0.5rem;
    padding: 0.75rem;
    background: var(--ui-white);
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    unicode-bidi: plaintext;
}

.comments_bubble_EoxhN::before {
    position: absolute;
    top: -1px;
    left: -11px;
    width: 10px;
    height: 8px;
    border: 1px solid var(--ui-black-transparent);
    border-right: 0;
    border-radius: 0 0 0 8px;
    background: var(--ui-white);
    content: "";
}

[dir="rtl"] .comments_comment_G7vkz .comments_bubble_EoxhN {
    border-radius: 0.5rem 0 0.5rem 0.5rem;
}

[dir="rtl"] .comments_comment_G7vkz .comments_bubble_EoxhN::before {
    left: auto;
    right: -11px;
    border-right: 1px solid var(--ui-black-transparent);
    border-left: 0;
    border-radius: 0 0 8px 0;
}

@media (max-width: 480px) {
    .comments_avatar-container_HOEt7 {
        width: 2rem;
        height: 2rem;
        flex-basis: 2rem;
    }
}

.comments_comment-actions_pBC43 {
    -webkit-margin-start: auto;
            margin-inline-start: auto;
    opacity: 0;
    pointer-events: none;
}

.comments_comment_G7vkz:hover .comments_comment-actions_pBC43,
.comments_comment_G7vkz:focus-within .comments_comment-actions_pBC43,
.comments_comment_G7vkz[data-deleting="true"] .comments_comment-actions_pBC43 {
    opacity: 1;
    pointer-events: auto;
}

.comments_delete-button_sJmuv {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.25rem;
    border: 0;
    border-radius: 0.25rem;
    background: transparent;
    color: var(--text-primary);
    font: inherit;
    font-size: 0.75rem;
    cursor: pointer;
    opacity: 0.65;
}

.comments_delete-button_sJmuv:hover,
.comments_delete-button_sJmuv:focus-visible {
    opacity: 1;
}

.comments_delete-button_sJmuv:focus-visible {
    outline: 2px solid var(--looks-secondary);
    outline-offset: 2px;
}

.comments_delete-button_sJmuv:disabled {
    cursor: default;
    opacity: 0.5;
}

.comments_delete-icon_HI_CZ {
    width: 1rem;
    height: 1rem;
    background-color: currentColor;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / contain no-repeat;
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / contain no-repeat;
}

@media (hover: none), (pointer: coarse) {
    .comments_comment-actions_pBC43 {
        opacity: 1;
        pointer-events: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/dash-comments/comments.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,2DAA2D;IAC3D,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,6CAA6C;IAC7C,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;IACtB,oBAAoB;IACpB,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;IACzC,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;;;IAGI,eAAe;IACf,aAAa;AACjB;;AAEA;;IAEI,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;YAClB,yBAAyB;IACjC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,6CAA6C;IAC7C,qCAAqC;IACrC,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,WAAW;IACX,6CAA6C;IAC7C,eAAe;IACf,wBAAwB;IACxB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mDAAmD;IACnD,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI,0BAA0B;YAClB,yBAAyB;IACjC,UAAU;IACV,oBAAoB;AACxB;;AAEA;;;IAGI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,wEAAyE;IACzE,gFAAiF;AACrF;;AAEA;IACI;QACI,UAAU;QACV,oBAAoB;IACxB;AACJ","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.content {\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 0;\n    padding: 0.5rem;\n}\n\n.metadata,\n.actions {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.compose,\n.list {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    color: var(--text-primary);\n}\n\n.compose,\n.comment {\n    display: flex;\n    align-items: flex-start;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.avatar-container {\n    width: 3rem;\n    height: 3rem;\n    flex: 0 0 3rem;\n}\n\n.avatar {\n    box-sizing: border-box;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 4px;\n    object-fit: cover;\n}\n\n.body {\n    flex: 1;\n    min-width: 0;\n}\n\n.input {\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    min-height: 5rem;\n    padding: 0.75rem;\n    border: 2px solid var(--ui-black-transparent);\n    border-radius: 5px;\n    resize: vertical;\n    background: var(--input-background);\n    color: var(--text-primary);\n    font: inherit;\n}\n\n.input:focus {\n    outline: none;\n    border-color: var(--looks-secondary);\n}\n\n.actions {\n    margin-top: 0.4rem;\n}\n\n.button,\n.secondary-button {\n    cursor: pointer;\n    border: 1px solid transparent;\n    border-radius: 0.25rem;\n    padding: 0.6rem 1rem;\n    background: var(--looks-secondary);\n    color: white;\n    font: inherit;\n    font-weight: bold;\n}\n\n.secondary-button {\n    border-color: var(--ui-black-transparent);\n    background: var(--ui-tertiary);\n    color: var(--text-primary);\n}\n\n.button:disabled,\n.secondary-button:disabled,\n.input:disabled {\n    cursor: default;\n    opacity: 0.55;\n}\n\n.button:focus-visible,\n.secondary-button:focus-visible {\n    outline: 2px solid var(--looks-secondary);\n    outline-offset: 2px;\n}\n\n.counter {\n    -webkit-margin-start: auto;\n            margin-inline-start: auto;\n    font-size: 0.75rem;\n}\n\n.list {\n    list-style: none;\n    padding: 0;\n    margin: 1.5rem 0 0;\n}\n\n.metadata {\n    margin-bottom: 0.5rem;\n}\n\n.metadata a {\n    color: var(--link-color);\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.metadata a:hover {\n    text-decoration: underline;\n}\n\n.metadata time {\n    font-size: 0.75rem;\n}\n\n.bubble {\n    position: relative;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0 0.5rem 0.5rem 0.5rem;\n    padding: 0.75rem;\n    background: var(--ui-white);\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n    unicode-bidi: plaintext;\n}\n\n.bubble::before {\n    position: absolute;\n    top: -1px;\n    left: -11px;\n    width: 10px;\n    height: 8px;\n    border: 1px solid var(--ui-black-transparent);\n    border-right: 0;\n    border-radius: 0 0 0 8px;\n    background: var(--ui-white);\n    content: \"\";\n}\n\n[dir=\"rtl\"] .comment .bubble {\n    border-radius: 0.5rem 0 0.5rem 0.5rem;\n}\n\n[dir=\"rtl\"] .comment .bubble::before {\n    left: auto;\n    right: -11px;\n    border-right: 1px solid var(--ui-black-transparent);\n    border-left: 0;\n    border-radius: 0 0 8px 0;\n}\n\n@media (max-width: 480px) {\n    .avatar-container {\n        width: 2rem;\n        height: 2rem;\n        flex-basis: 2rem;\n    }\n}\n\n.comment-actions {\n    -webkit-margin-start: auto;\n            margin-inline-start: auto;\n    opacity: 0;\n    pointer-events: none;\n}\n\n.comment:hover .comment-actions,\n.comment:focus-within .comment-actions,\n.comment[data-deleting=\"true\"] .comment-actions {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.delete-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    padding: 0.25rem;\n    border: 0;\n    border-radius: 0.25rem;\n    background: transparent;\n    color: var(--text-primary);\n    font: inherit;\n    font-size: 0.75rem;\n    cursor: pointer;\n    opacity: 0.65;\n}\n\n.delete-button:hover,\n.delete-button:focus-visible {\n    opacity: 1;\n}\n\n.delete-button:focus-visible {\n    outline: 2px solid var(--looks-secondary);\n    outline-offset: 2px;\n}\n\n.delete-button:disabled {\n    cursor: default;\n    opacity: 0.5;\n}\n\n.delete-icon {\n    width: 1rem;\n    height: 1rem;\n    background-color: currentColor;\n    mask: url(\"../delete-button/icon--delete.svg\") center / contain no-repeat;\n    -webkit-mask: url(\"../delete-button/icon--delete.svg\") center / contain no-repeat;\n}\n\n@media (hover: none), (pointer: coarse) {\n    .comment-actions {\n        opacity: 1;\n        pointer-events: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var content = `comments_content_nrpnl`;
export var metadata = `comments_metadata_ov0ZF`;
export var actions = `comments_actions_OFCZK`;
export var compose = `comments_compose_hPme1`;
export var list = `comments_list_wRH73`;
export var comment = `comments_comment_G7vkz`;
var _1 = `comments_avatar-container_HOEt7`;
export { _1 as "avatar-container" };
export var avatarContainer = `comments_avatar-container_HOEt7`;
export var avatar = `comments_avatar_GeUVF`;
export var body = `comments_body_TkxeC`;
export var input = `comments_input_ZfZgn`;
export var button = `comments_button_x1QJL`;
var _2 = `comments_secondary-button_l5cgD`;
export { _2 as "secondary-button" };
export var secondaryButton = `comments_secondary-button_l5cgD`;
export var counter = `comments_counter_tj80N`;
export var bubble = `comments_bubble_EoxhN`;
var _3 = `comments_comment-actions_pBC43`;
export { _3 as "comment-actions" };
export var commentActions = `comments_comment-actions_pBC43`;
var _4 = `comments_delete-button_sJmuv`;
export { _4 as "delete-button" };
export var deleteButton = `comments_delete-button_sJmuv`;
var _5 = `comments_delete-icon_HI_CZ`;
export { _5 as "delete-icon" };
export var deleteIcon = `comments_delete-icon_HI_CZ`;
export default ___CSS_LOADER_EXPORT___;
